import cx from "classnames";
import {Fragment, useEffect, useRef, useState} from 'react'
import { Combobox, Transition } from '@headlessui/react'
import { CheckIcon, SelectorIcon } from '@heroicons/react/solid'
import {deburr, find} from "lodash";

const ComboboxSelect = props => {
    const { handleChange, items, value } = props

    const [selected, setSelected] = useState({ label: (value && value !== '*') ? value : 'Toutes les spécialités', value: value ?? '*' })
    const [query, setQuery] = useState('')
    const button = useRef()

    const filteredItems =
        query === ''
            ? items
            : items.filter(item => {
                return deburr(item.label).toLowerCase().includes(deburr(query).toLowerCase())
            })

    const onChange = value => {
        const item = find(items, {value: value})

        if (selected !== null && selected.value === item.value) {
            setSelected(null)
        } else {
            setSelected(item)
        }
    }

    const onClick = () => {
        setSelected(null)
        setQuery('')
        button.current.click()
    }

    useEffect(() => {
        if (items.length === 0 || selected !== null || props.value === undefined) return;

        const item = find(items, {value: value})

        setSelected(item)
    }, [items])

    useEffect(() => {
        handleChange(selected)
    }, [selected])

    return (
        <div className={cx('relative', props.size ?? 'w-full md:w-72')}>
            <Combobox value={selected?.value} onChange={onChange}>
                <div className="relative">
                    <div className="relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left shadow focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-blue-300 sm:text-sm">
                        <Combobox.Input
                            className="w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0"
                            displayValue={() => selected?.label}
                            onChange={(event) => setQuery(event.target.value)}
                            onClick={onClick}
                        />
                        <Combobox.Button ref={button} className="absolute inset-y-0 right-0 flex items-center pr-2">
                            <SelectorIcon
                                className="h-5 w-5 text-gray-400"
                                aria-hidden="true"
                            />
                        </Combobox.Button>
                    </div>
                    <Transition
                        as={Fragment}
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                        afterLeave={() => setQuery('')}
                    >
                        <Combobox.Options className="absolute z-50 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-md ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                            {filteredItems.length === 0 && query !== '' ? (
                                <div className="relative cursor-default select-none py-2 px-4 text-gray-700">
                                    Pas de résultats
                                </div>
                            ) : (
                                filteredItems.map(item => (
                                    <Combobox.Option
                                        key={item.label}
                                        className={({active}) => cx('relative cursor-default select-none py-2 pl-10 pr-4', {'bg-indigo-800 text-white': active, 'text-gray-900': !active})}
                                        value={item.value}
                                    >
                                        {({ selected, active }) => (
                                            <>
                                                <span
                                                    className={`block truncate ${
                                                        selected ? 'font-medium' : 'font-normal'
                                                    }`}
                                                >
                                                  {item.label}
                                                </span>
                                                {selected ? (
                                                    <span className={cx('absolute inset-y-0 left-0 flex items-center pl-3', {'text-white': active, 'text-indigo-800': !active})}>
                                                        <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                    </span>
                                                ) : null}
                                            </>
                                        )}
                                    </Combobox.Option>
                                ))
                            )}
                        </Combobox.Options>
                    </Transition>
                </div>
            </Combobox>
        </div>
    )
}

export default ComboboxSelect